<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  name: String,
});

const station = ref([]);
const modes = [
  "tube",
  "overground",
  "elizabeth-line",
  "dlr",
  "national-rail",
].join(","); // TFL API modes for our initial query

const search = async (query) => {
  if (query.trim() === "") {
    station.value = "";
  } else {
    const response = await fetch(
      `https://api.tfl.gov.uk/StopPoint/Search?query=${encodeURIComponent(
        query.toLowerCase()
      )}&maxResults=1&app_id=4fa5fbc524c345dc82387f43b33b7038&app_key=2696ed4c27f24913a221b4e3de8e7ab8`
    );
    const responseJson = await response.json();

    // Fetch detailed information for each match
    const stationsWithModes = await Promise.all(
      responseJson.matches.map(async (match) => {
        const details = await fetchStationDetails(match.id);
        return {
          name: match.name,
          modes: details.modes.filter((mode) => modes.includes(mode)),
        };
      })
    );

    station.value = stationsWithModes[0];
  }
};

const fetchStationDetails = async (stationId) => {
  const response = await fetch(
    `https://api.tfl.gov.uk/StopPoint/${stationId}?app_id=4fa5fbc524c345dc82387f43b33b7038&app_key=2696ed4c27f24913a221b4e3de8e7ab8`
  );
  return await response.json();
};

onMounted(async () => {
  await search(props.name);
});
</script>

<template>
  <div class="flex items-center">
    <i v-for="(mode, index) in station.modes" :key="index" class="pr-10">
      <img
        :src="require(`@images/tfl/${mode}.png`)"
        :alt="mode"
        class="w-[24px]" />
    </i>
    {{ station.name }}
  </div>
</template>

<style scoped lang="scss"></style>
